interface TabItem {
  key: string
  label: string
  count?: number
}

interface TabsProps {
  items: TabItem[]
  activeKey: string
  onChange: (key: string) => void
}

export function Tabs({ items, activeKey, onChange }: TabsProps) {
  return (
    <ul className="nav nav-tabs mb-3">
      {items.map((item) => (
        <li className="nav-item" key={item.key}>
          <button
            type="button"
            className={`nav-link ${item.key === activeKey ? 'active' : ''}`.trim()}
            onClick={() => onChange(item.key)}
          >
            {item.label}
            {item.count != null && (
              <span className="badge bg-light text-dark border ms-2">{item.count}</span>
            )}
          </button>
        </li>
      ))}
    </ul>
  )
}
